import { useTheme as useEmotionTheme } from '@emotion/react';
import { Theme } from '@mos-cat/ds-theme';
import { createHook } from 'reakit-system';
import { BoxHTMLProps } from 'reakit';

export const useTheme = createHook<{ theme: Theme }, BoxHTMLProps>({
  keys: ['theme'],
  useOptions(options) {
    if (options.theme) return options;
    return { ...options, theme: useEmotionTheme() };
  },
});
